var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "url(#paint0_linear_579_13365)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.05564 19.7889C14.886 17.2487 18.7739 15.574 20.7192 14.7649C26.2734 12.4547 27.4275 12.0534 28.1798 12.0402C28.3452 12.0373 28.7151 12.0783 28.9548 12.2727C29.1571 12.4369 29.2128 12.6587 29.2394 12.8143C29.266 12.97 29.2992 13.3246 29.2728 13.6017C28.9719 16.7641 27.6695 24.4386 27.0069 27.9806C26.7266 29.4794 26.1746 29.9819 25.6401 30.0311C24.4787 30.138 23.5967 29.2636 22.4718 28.5262C20.7116 27.3723 19.7171 26.654 18.0085 25.528C16.0339 24.2268 17.3139 23.5116 18.4393 22.3428C18.7338 22.0369 23.8511 17.3823 23.9501 16.9601C23.9625 16.9072 23.974 16.7104 23.8571 16.6065C23.7401 16.5025 23.5676 16.5381 23.443 16.5663C23.2665 16.6064 20.4544 18.465 15.0069 22.1423C14.2087 22.6904 13.4857 22.9574 12.838 22.9434C12.1239 22.928 10.7502 22.5397 9.72904 22.2077C8.47654 21.8006 7.48108 21.5853 7.56776 20.8939C7.61291 20.5337 8.10887 20.1654 9.05564 19.7889Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_579_13365",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.18640a7404c758f1d6da8d0483cb7cdb.svg";
export { ForwardRef as ReactComponent };